module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27018.13a502eba9315a70ab7388a9fe68f413.png";